import React, { Component } from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import Api from "../../../Services/Api";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDate from "../../../modules/SimpleDate";
import M from "moment";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import * as R from "ramda";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { HttpStatus } from "../../common/Constants";
import {
  checkAndHandleError,
  contructQueryParam,
  fetchDataAsync,
  FormatCurrencyRupiah,
  FormatCurrencyWithoutSymbol,
} from "../../../Services/Utils";
import { mapToObjectDDL } from "../../common/mapper";
import SimpleTextArea from "../../../modules/simpleTextArea";
import SimpleUploadExcel from "./SimpleUploadExcel";
import { defaultTableChange } from "../../../modules/custom/customTable";

class MasterPartPriceModifying extends Component {
  tableColumns = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (value, tableMeta) => {
                return <>{tableMeta.rowIndex + 1}</>;
            },
            sort: false,
        },
    },
    {
      name: "kodePart",
      label: (
        <>
          Kode Part <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        customBodyRender: (val, { rowIndex }) => {
          const { dataPart, dataToDetail } = this.state;
          const saved = dataToDetail[rowIndex].saved;

          if (saved) return <>{val}</>;

          const currentPart = dataPart.find((p) => p.value === val);

          return (
            <>
              <SimpleDDL
                id="input_text_kode_part"
                box="search"
                name="kodePart"
                readOnly={!this.props.displayActive}
                containerclassname="margin-bottom-none width width-250px"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    position: "relative",
                    fontFamily:
                      "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                  }),
                }}
                options={dataPart.map((item) => ({
                  label: `${item.value} - ${item.label}`,
                  value: item.value,
                  partName: item.label,
                  category: item.category,
                }))}
                value={
                  val
                    ? {
                        label: `${val} - ${currentPart?.label || ""}`,
                        value: val,
                      }
                    : ""
                }
                formatOptionLabel={(option, { context }) =>
                  context === "value" ? option.value : option.label
                }
                onChange={(selected) =>
                  this.handleRowValueChange(rowIndex, "kodePart", selected)
                }
              />
              {this.state.errorDetail?.[`${rowIndex}_kodePart`] && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {this.state.errorDetail[`${rowIndex}_kodePart`]}
                </div>
              )}
            </>
          );
        },
      },
    },
    {
      name: "partName",
      label: (
        <>
          Nama Part <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        customBodyRender: (val, { rowIndex }) => {
          let save = this.state.dataToDetail[rowIndex].saved;
          if (save) {
            return <>{val}</>;
          } else {
            return (
              <>
                <SimpleDDL
                  id="input_text_kode_part"
                  box="search"
                  name="partName"
                  readOnly={!this.props.displayActive}
                  containerclassname="margin-bottom-none width width-250px"
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      position: "relative",
                      fontFamily:
                        "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                    }),
                  }}
                  options={this.state.dataPart}
                  value={this.findLabel(
                    this.state.dataToDetail[rowIndex].kodePart,
                    this.state.dataPart
                  )}
                  onChange={(event) => {
                    this.handleRowValueChange(rowIndex, "partName", event);
                  }}
                />
                {this.state.errorDetail?.[`${rowIndex}_partName`] && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {this.state.errorDetail[`${rowIndex}_partName`]}
                  </div>
                )}
              </>
            );
          }
        },
      },
    },
    {
      name: "partCategory",
      label: "Part Category",
      options: {
        customBodyRender: (val, { rowIndex }) => {
          let saved = this.state.dataToDetail[rowIndex].saved;
          if (saved) {
            return <>{val}</>;
          } else {
            return (
              <>
                <SimpleInput
                  id="input_text_part_category"
                  name="partCategory"
                  readOnly={true}
                  containerclassname="margin-bottom-none width width-250px"
                  value={val}
                />
                {this.state.errorDetail?.[`${rowIndex}_partName`] && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "20px",
                    }}
                  ></div>
                )}
              </>
            );
          }
        },
      },
    },
    {
      name: "partPrice",
      label: (
        <>
          Harga <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        customBodyRender: (val, { rowIndex }) => {
          let saved = this.state.dataToDetail[rowIndex].saved;
          if (saved) {
            return <>{FormatCurrencyRupiah({ number: val })}</>;
          } else {
            return (
              <>
                <SimpleInput
                  id="input_text_off_price"
                  prefix="Rp."
                  name="partPrice"
                  containerclassname="margin-bottom-none width width-250px"
                  box="number"
                  value={FormatCurrencyWithoutSymbol({ number: val })}
                  onValueChange={({ value }) => {
                    let target = { value: value };
                    this.handleRowValueChange(rowIndex, "partPrice", target);
                  }}
                />
                {this.state.errorDetail?.[`${rowIndex}_partPrice`] && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {this.state.errorDetail[`${rowIndex}_partPrice`]}
                  </div>
                )}
              </>
            );
          }
        },
      },
    },
    {
      name: "saved",
      label: "Action",
      options: {
        customBodyRender: (val, { rowIndex }) => (
          <FlexView style={{ gap: "10px" }}>
            {val && (
              <SimpleButton
                type="button"
                category="action_button"
                style={{ backgroundColor: "transparent" }}
                icon={
                  <i
                    style={{ fontSize: 20, color: "red" }}
                    className="fa fa-pencil-alt"
                  />
                }
                onClick={() => this.handleChangeSavedState(rowIndex)}
              />
            )}
            {!val && (
              <SimpleButton
                type="button"
                category="action_button"
                style={{ backgroundColor: "transparent" }}
                icon={
                  <i
                    style={{ fontSize: 20, color: "red" }}
                    className="fa fa-save"
                  />
                }
                onClick={() => this.handleCheckPart(rowIndex)}
              />
            )}
            <SimpleButton
              type="button"
              category="action_button"
              style={{ backgroundColor: "transparent" }}
              icon={
                <i
                  style={{ fontSize: 20, color: "red" }}
                  className="fa fa-times-circle"
                />
              }
              onClick={() => this.handleDeleteAlertModalVisibility(rowIndex)}
            />
          </FlexView>
        ),
        setCellProps: () => ({ width: "10%" }),
        sort: false,
      },
    },
  ];

  handleCheckPart = (rowIndex) => {
    const { dataToDetail } = this.state;
    const row = dataToDetail[rowIndex];
    const errors = {};

    if (!row.kodePart) {
      errors[`${rowIndex}_kodePart`] = "Field wajib diisi.";
    }
    if (!row.partName) {
      errors[`${rowIndex}_partName`] = "Field wajib diisi.";
    }
    if (!row.partPrice || row.partPrice === "0" || row.partPrice === 0) {
      errors[`${rowIndex}_partPrice`] = "Field wajib diisi.";
    }

    if (Object.keys(errors).length > 0) {
      this.setState((prevState) => ({
        ...prevState,
        errorDetail: { ...prevState.errorDetail, ...errors },
      }));
      return;
    }

    const listPart = dataToDetail
      .filter((i, idx) => idx !== rowIndex)
      .map((i) => i.kodePart);

    if (listPart.includes(row.kodePart)) {
      return this.handleDuplicatePartAlert();
    }

    this.setState((prevState) => {
      const updatedErrors = { ...prevState.errorDetail };
      delete updatedErrors[`${rowIndex}_kodePart`];
      delete updatedErrors[`${rowIndex}_partName`];
      delete updatedErrors[`${rowIndex}_partPrice`];

      return { ...prevState, errorDetail: updatedErrors };
    });

    this.handleChangeSavedState(rowIndex);
  };

  handleChangeSavedState = (rowIndex) => {
    let updatedData = this.state.dataToDetail.map((item, index) => {
      if (index === rowIndex) {
        return {
          ...item,
          saved: !item.saved,
        };
      }
      return item;
    });

    this.setState((prevState) => ({
      ...prevState,
      dataToDetail: updatedData,
    }));
  };

  handleRemoveRow = (rowIndex) => {
    this.setState((prevState) => {
      const dataToDetail = [...prevState.dataToDetail];
      dataToDetail.splice(rowIndex, 1);
      return { dataToDetail, deleteAlert: !prevState.deleteAlert };
    });
  };

  handleGlobalValueChange = (input, event) => {
    let valueToStore = "";
    if (Array.isArray(event)) {
      valueToStore = event.map((item) => ({
        ...item,
        refCabangId: item.refCabangId || null,
      }));
    } else if (event && typeof event === "object") {
      if (input === "mdId") {
        valueToStore = event.value;
      } else {
        valueToStore = { ...event, refCabangId: event.refCabangId || null };
      }
    } else if (event?.target) {
      valueToStore = event.target.value;
    }

    this.setState(
      (prevState) => ({
        dataToStore: {
          ...prevState.dataToStore,
          [input]: valueToStore,
        },
      }),
      () => {
        if (input === "mdId") {
          const supplierCode = (event && event.value) || valueToStore || null;
          if (supplierCode) {
            this.fetchCabangByMainDealer(supplierCode);
          }
        }
      }
    );
  };

  handleValueChange = async (name, value) => {
    this.setState((prevState) => ({
      ...prevState,
      dataToStore: {
        ...prevState.dataToStore,
        [name]: value,
      },
    }));
  };

  // handleCheckPart = (input, event) => {
  //   this.setState((prevState) => ({
  //     ...prevState,
  //     checkPart: event.value,
  //   }));
  // };

  handleRowValueChange = (rowIndex, input, event) => {
    this.setState((prevState) => {
      const updatedData = [...prevState.dataToDetail];
      const selectedPart = prevState.dataPart.find(
        (p) => p.value === event.value || p.label === event.label
      );

      let updatedRow = { ...updatedData[rowIndex] };

      switch (input) {
        case "kodePart":
        case "partName":
          updatedRow = {
            ...updatedRow,
            kodePart: selectedPart?.value || event.value,
            partName: selectedPart?.label || event.partName || event.label,
            partCategory: selectedPart?.category || updatedRow.partCategory,
          };
          break;

        default:
          updatedRow = {
            ...updatedRow,
            [input]: event.value,
          };
          break;
      }

      updatedData[rowIndex] = updatedRow;

      return { ...prevState, dataToDetail: updatedData };
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      uploadFileModalVisible: false,
      printModalVisible: false,
      dataMainDealer: [],
      dataCabang: [],
      dataPart: [],
      dataToStore: {},
      dataToDetail: [],
      originalData: [],
      checkPart: "",
      dataBackup: [],
      dataFromDb: {},
      previewDocumentCode: "",
      keyword: null,
      isLoading: false,
      rowsPerPage: 5,
      page: 0,
      simpleAlert: false,
      saveAlert: false,
      formRef: null,
      errorMessage: {},
      deleteAlert: false,
      selectedRowIndex: null,
      saveSubmitAlert: false,
      duplicatePart: false,
      errorDetail: {},
      pagination: {
          page: 1,
          limit: 5,
          totalData: 0,
      },
    };
  }

  async componentDidMount() {
    try {
      this.handleTriggerLoading(true);
      await this.fetchMainDealer();
      const id = this.props.id?.trim?.() || "";

      if (id !== "") {
        const response = await Api.create(
          "NAGAMAS_MASTER_DATA"
        ).getMasterPartPriceById(id);

        if (response.ok && response.data?.data) {
          this.mapData(response.data.data);
          await this.fetchCabangByMainDealer(this.state.dataToStore.mdId);
          this.setState((prevValue) => ({
                ...prevValue,
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.data.length,
                }
            }));
        } else {
          console.error(
            "Gagal fetch data part price:",
            response.problem || response
          );
        }
      } else {
        const body = { transactionType: "MasterPartPrice" };
        const response = await Api.create(
          "NAGAMAS_MASTER_DATA"
        ).getQrFormatWithoutCabang(body);

        if (response.ok && response.data?.data) {
          const text = response.data.data;
          this.setState((prevState) => ({
            ...prevState,
            previewDocumentCode: text,
            dataToStore: {
              ...prevState.dataToStore,
              partPriceId: null,
              // kodeCabang: this.props.kodeCabang?.value || "",
            },
          }));
        } else {
          console.error("Gagal fetch QR format:", response.problem || response);
        }
      }
    } catch (error) {
      console.error("Terjadi error di componentDidMount:", error);
    } finally {
      this.handleTriggerLoading(false);
    }
  }

  mapData = (data) => {
    const {
      partPriceId,
      effectiveDate,
      mdId,
      note,
      masterPartPriceCabang,
      masterPartPriceDetail,
    } = data;

    const mappedCabang = masterPartPriceCabang.map((cabang) => ({
      value: cabang.kodeCabang,
      label: cabang.namaCabang,
      refCabangId: cabang.refCabangId,
    }));

    const mappedDetail = masterPartPriceDetail.map((item, index) => ({
      no: index + 1,
      kodePart: item.dataMasterPart.kodePart,
      partName: item.dataMasterPart.partName,
      partCategory: item.dataMasterPart.partCategory,
      partPrice: item.partPrice,
      satuan: item.dataMasterPart.satuan,
      status: item.dataMasterPart.status,
      partPriceDetailId: item.partPriceDetailId,
      saved: true,
    }));

    this.setState((prevState) => ({
      ...prevState,
      dataFromDb: {
        partPriceId,
        mdId,
        effectiveDate,
        note,
        masterPartPriceCabang: mappedCabang.map((x) => x.value),
      },
      dataToStore: {
        ...prevState.dataToStore,
        partPriceId,
        mdId,
        effectiveDate,
        note,
        masterPartPriceCabang: mappedCabang,
      },
      dataToDetail: mappedDetail,
      kodeCabang: mappedCabang,
      originalData: mappedDetail,
    }));
  };

  handleUploadFileModalVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      uploadFileModalVisible: !prevState.uploadFileModalVisible,
    }));
  };

  fetchMainDealer = async () => {
    const [responseMainDealer, responsePart] = await Promise.all([
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierMainDealer,
        menuName: "Master Part Price",
        setError: this.props.setError,
        args: contructQueryParam({ kodeCabang: this.props.kodeCabang.value }),
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart,
        menuName: "Master Part Price",
        setError: this.props.setError,
        args: { paramFilters: { status: "ACTIVE" }, limit: null, page: null },
      }),
    ]);

    if (responseMainDealer.ok && responsePart.ok) {
      const dataMainDealer = responseMainDealer.data.data.map((item) => ({
        label: item.supplierName,
        value: item.supplierCode,
      }));
      const dataPart = responsePart.data.data.map((item) => ({
        label: item.partName,
        value: item.kodePart,
        category: item.partCategory,
      }));
      this.setState((prevState) => ({
        ...prevState,
        dataMainDealer: dataMainDealer,
        dataPart: dataPart,
      }));
    }
  };

  fetchCabangByMainDealer = async (dealerCode) => {
    try {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getCabangbyMainDealer,
        menuName: "Master Part Price",
        setError: this.props.setError,
        args: dealerCode,
      });

      if (response.ok && response.data?.data) {
        const allowedCabang = this.props.menuAccess.map(
          (data) => data.idRefObj
        );

        const dataCabang = response.data.data
          .filter((item) => allowedCabang.includes(item.idCabang))
          .map((item) => ({
            label: item.nameCabang,
            value: item.idCabang,
            namaCabang: item.nameCabang,
          }));

        this.setState({
          dataCabang,
        });
      }
    } catch (error) {
      console.error("Gagal fetch cabang by main dealer:", error);
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleInputDateChange = (name, value) => {
    this.setState((prevState) => ({
      ...prevState,
      dataToStore: {
        ...this.state.dataToStore,
        [name]: M(value).format("DD-MM-YYYY"),
      },
    }));
  };

  findLabel = (value, options) => {
    if (!value) return "";
    if (Array.isArray(value)) {
      return value
        .map((value) => options.find((item) => item.value === value))
        .filter((item) => item);
    }
    const label = options.find((item) => item.value === value);
    return label ? label : "";
  };

  handleAddRow = () => {
    const newRow = {
      kodePart: null,
      partName: null,
      partCategory: null,
      price: null,
      saved: false,
    };
    this.setState((prevState) => ({
      ...prevState,
      dataToDetail: [...prevState.dataToDetail, newRow],
    }));
  };

  handleClose = () => {
    this.setState(
      (prevState) => ({
        ...prevState,
        dataToDetail: [],
        dataToStore: {},
      }),
      () => {
        this.props.handleDisplatActive();
        this.props.onClose();
      }
    );
  };

  handleBeforeSubmit = (text) => {
    if (this.validate()) {
      return;
    }

    this.handleSaveSubmitAlertModalVisibility(text);
  };

  handleSubmit = () => {
    const dataToDetail = this.state.dataToDetail.map((item) => ({
      partPriceDetailId: item.partPriceDetailId || null,
      partCode: item.kodePart,
      partPrice: parseFloat(item.partPrice),
    }));

    const uniqueCodes = new Set(dataToDetail.map((d) => d.partCode));
    const hadDuplicate = uniqueCodes.size !== dataToDetail.length;

    if (hadDuplicate) {
      return this.handleDuplicatePartAlert();
    }

    const dataBackup = (this.state.dataBackup || []).map((item) => ({
      partPriceDetailId: item.partPriceDetailId,
      partCode: item.kodePart,
      partPrice: item.partPrice,
    }));

    const masterPartPriceCabang = (
      this.state.dataToStore.masterPartPriceCabang || []
    ).map((item) => ({
      refCabangId: item.refCabangId || null,
      kodeCabang: item.value,
      namaCabang: item.label,
    }));

    const body = {
      ...this.state.dataToStore,
      masterPartPriceCabang,
      masterPartPriceDetail: [...dataToDetail, ...dataBackup],
    };

    this.props.onSubmit(body);
  };

  validate = () => {
    const newErrors = {};
    const mandatoryField = ["mdId", "effectiveDate", "masterPartPriceCabang"];
    const { dataToStore, dataToDetail } = this.state;

    mandatoryField.forEach((field) => {
      if (R.or(!dataToStore[field], R.isEmpty(dataToStore[field]))) {
        newErrors[field] = "Field Belum Diisi!";
      }
    });

    if (!dataToDetail || dataToDetail.length === 0) {
      newErrors["emptyDetail"] = "Terdapat data yang belum lengkap";
      this.handleSaveAlertModalVisibility("Terdapat data yang belum lengkap");

      this.setState((prevState) => ({
        ...prevState,
        errorMessage: {
          ...prevState.errors,
          ...newErrors,
        },
      }));

      return true;
    }

    dataToDetail.forEach((item, index) => {
      if (R.or(!item.kodePart, R.isEmpty(item.kodePart))) {
        newErrors[`kodePart_${index}`] = "Field Belum Diisi!";
      }
    });

    const hasUnSavedData = dataToDetail.some((item) => item.saved === false);
    if (hasUnSavedData) {
      newErrors["unsavedData"] = "Terdapat data yang belum lengkap";
      this.handleSaveAlertModalVisibility("Terdapat data yang belum lengkap");
    }

    this.setState((prevState) => ({
      ...prevState,
      errorMessage: {
        ...prevState.errors,
        ...newErrors,
      },
    }));

    return Object.keys(newErrors).length !== 0;
  };

  handleDeleteConfirmation = (e) => {
    e.preventDefault();
    this.setState({ simpleAlert: false }, () => {
      this.handleSubmit(e);
    });
  };

  handleSaveAlertModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      saveAlert: !prevState.saveAlert,
    }));
  };

  handleDeleteAlertModalVisibility = (rowIndex) => {
    const data = this.state.dataToDetail[rowIndex];
    const variant = this.state.dataPart.find(
      (item) => item.value === data?.kodePart
    );
    const text =
      "Apakah anda yakin ingin menghapus data Harga " + variant?.label + " ?";
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      deleteAlert: !prevState.deleteAlert,
      selectedRowIndex: rowIndex,
    }));
  };

  handleSaveSubmitAlertModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      saveSubmitAlert: !prevState.saveSubmitAlert,
    }));
  };

  checkIfDelete = () => {
    this.setState((prevState) => ({
      ...prevState,
      simpleAlert: !prevState.simpleAlert,
    }));
  };

  filterData = () => {
    this.setState({
      keyword: this.state.checkPart
    })
  };

  resetData = () => {
    this.setState(prev=>({
      ...prev,
      keyword: null,
      checkPart: null
    }))
  };

  handlePrint = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      printModalVisible: !prevValue.printModalVisible,
    }));
  };

  handleOnSubmitFile = async (file) => {
    try {
      this.handleTriggerLoading();

      const renamedFile = new File([file], "TEMPLATE_MASTER_HARGA_PART.xlsx", {
        type: file.type,
      });

      const formData = new FormData();
      formData.append("file", renamedFile);

      const res = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).uploadTemplateMasaterPartPrice(formData);

      if (res.ok) {
        // if (res.data.status === HttpStatus.FAILED) {
        //   this.handleTriggerLoading();
        //   checkAndHandleError(res, this.props.setError, "Master Part Price");
        //   return false;
        // }

        if (res.data.status === HttpStatus.SUCCESS) {
          const { dataPart } = this.state;
          const existingData = this.state.dataToDetail || [];

          const transformedData = res.data.data.map((item) => {
            const foundPart = dataPart.find((p) => p.value === item.partCode);

            return {
              kodePart: item.partCode,
              partName: item.partName || foundPart?.label || "-",
              partCategory: foundPart ? foundPart.category : "-",
              partPrice: item.partPrice,
              saved: true,
            };
          });

          const mergedData = [...existingData];

          transformedData.forEach((newItem) => {
            const existingIndex = mergedData.findIndex(
              (d) => d.kodePart === newItem.kodePart
            );

            if (existingIndex === -1) {
              mergedData.push(newItem);
            } else {
              mergedData[existingIndex] = {
                ...mergedData[existingIndex],
                ...newItem,
                saved: true,
              };
            }
          });

          this.setState({
            dataToDetail: mergedData,
            originalData: mergedData,
          });

          this.handleTriggerLoading(false);
          return true;
        }
      }
    } catch (error) {
      //
    }

    this.handleTriggerLoading(false);
    return false;
  };

  handleDownloadLogError = async (file) => {
    try {
      const renamedFile = new File([file], "TEMPLATE_MASTER_HARGA_PART.xlsx", {
        type: file.type,
      });

      const formData = new FormData();
      formData.append("file", renamedFile);

      const res = await Api.create(
        "NAGAMAS_MASTER_DATA_FILE"
      ).getDownloadLogErrorPartPrice(formData);

      if (!res.ok) {
        console.error(
          "Gagal download log error:",
          res.problem || res.originalError
        );
        return;
      }

      if (res.data?.status === HttpStatus.FAILED) {
        console.warn("BE mengembalikan status gagal:", res.data.message);
        return;
      }

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "TEMPLATE_MASTER_HARGA_PART_LOG.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Terjadi error saat download log error:", error);
    }
  };

  handleDownloadTemplate = async () => {
    try {
      const res = await Api.create(
        "NAGAMAS_MASTER_DATA_FILE"
      ).getTemplateExcelMasterPartPrice();
      if (res.ok) {
        if (checkAndHandleError(res, this.props.setError, "Master Part Price"))
          return;
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = "TEMPLATE_MASTER_HARGA_PART.xlsx";
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  handleDuplicatePartAlert = () => {
    this.setState((prevState) => ({
      ...prevState,
      duplicatePart: !prevState.duplicatePart,
      saveSubmitAlert: false,
    }));
  };

  handleSearchPart = (field, target) => {
    const value = target.value;

    this.setState({ [field]: value }, () => {
      if (value.trim() === "") {
        this.setState({
          dataToDetail: this.state.originalData,
        });
      }
    });
  };

  // filterData = () => {
  //   const { checkPart, originalData } = this.state;

  //   if (!checkPart || checkPart.trim() === "") {
  //     this.setState({
  //       dataToDetail: originalData,
  //     });
  //     return;
  //   }

  //   const filtered = originalData.filter((item) =>
  //     item.kodePart.toLowerCase().includes(checkPart.toLowerCase())
  //   );

  //   this.setState({
  //     dataToDetail: filtered,
  //   });
  // };

  getDataDetail = () => {
    const {keyword} = this.state;
    // console.log(keyword)
    if(keyword){
      return this.state.dataToDetail.filter(
        (item) => item.kodePart === keyword
      )
    }
    return this.state.dataToDetail
  }

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const {pagination} = this.state;
    return (
      <SimpleModal
        title={"Detail Harga Part"}
        visible={this.props.visible}
        onClickClose={this.handleClose}
        width="800px"
        height="600px"
        content={
          <ModalContainer>
            <form
              ref={(ref) => (this.formRef = ref)}
              onSubmit={this.handleSubmit}
            >
              <FlexView column marginBottom={20}>
                <div className="grid grid-3x grid-mobile-none gap-20px">
                  <div id="grid-1">
                    <SimpleInput
                      id="input_text_kode_document"
                      name="partPriceId"
                      label="Kode Document"
                      containerclassname="width width-250px"
                      readOnly={true}
                      value={
                        this.state.previewDocumentCode
                          ? this.state.previewDocumentCode
                          : this.state.dataFromDb.partPriceId
                      }
                      onChange={(e) =>
                        this.handleGlobalValueChange("partPriceId", e)
                      }
                    />
                    <SimpleDDL
                      id="ddl_main_dealer"
                      name="mdId"
                      label="Main Dealer"
                      containerclassname="width width-250px"
                      box="search"
                      readOnly={!this.props.displayActive}
                      mandatory
                      errorMessage={this.state.errorMessage?.mdId}
                      options={this.state.dataMainDealer}
                      value={this.findLabel(
                        this.state.dataToStore.mdId
                          ? this.state.dataToStore.mdId
                          : this.state.dataFromDb.mdId,
                        this.state.dataMainDealer
                      )}
                      onChange={(e) => this.handleGlobalValueChange("mdId", e)}
                    />
                  </div>
                  <div id="grid-2">
                    <div className="width-150px" style={{ width: "250px" }}>
                      <SimpleDate
                        label="Tanggal Berlaku"
                        id="select_date_to"
                        style={{ width: "100%" }}
                        mandatory
                        errorMessage={this.state.errorMessage?.effectiveDate}
                        disabled={!this.props.displayActive}
                        date={this.state.dataToStore.effectiveDate}
                        onChange={(value) =>
                          this.handleInputDateChange("effectiveDate", value)
                        }
                      />
                    </div>
                    <SimpleDDL
                      id="select_options_untuk_cabang"
                      label="Cabang Berlaku"
                      name="masterPartPriceCabang"
                      containerclassname="width width-250px"
                      box="multiselect"
                      mandatory
                      errorMessage={
                        this.state.errorMessage?.masterPartPriceCabang
                      }
                      readOnly={!this.props.displayActive}
                      options={this.state.dataCabang}
                      value={this.state.dataToStore.masterPartPriceCabang || []}
                      onChange={(e) =>
                        this.handleGlobalValueChange("masterPartPriceCabang", e)
                      }
                    />
                  </div>
                  <div id="grid-3">
                    <SimpleTextArea
                      id="input_text_keterangan"
                      typeInputCase="normal"
                      name="note"
                      label="Keterangan"
                      errorMessage={this.state.errorData?.note}
                      value={this.state.dataToStore?.note || ""}
                      onChange={(e) =>
                        this.handleValueChange(e.target.name, e.target.value)
                      }
                    />
                  </div>
                </div>
              </FlexView>
              <FlexView
                vAlignContent="center"
                style={{
                  gap: "10px",
                  marginBottom: "15px",
                  justifyContent: "space-between",
                }}
              >
                <SimpleButton
                  text="Tambah"
                  type="button"
                  onClick={this.handleAddRow}
                />
                <FlexView>
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <SimpleInput
                      id="input_text_check_part"
                      name="checkPart"
                      containerclassname="margin-bottom-none"
                      placeholder="Kode Part"
                      value={this.state.checkPart}
                      onChange={(e) => {
                        const { target } = e;
                        this.handleSearchPart("checkPart", target);
                      }}
                    />
                  </FlexView>
                  <SimpleButton
                    className="margin-top-5px"
                    text="Cari"
                    type="button"
                    onClick={this.filterData}
                  />
                </FlexView>
              </FlexView>
              <SimpleDataTable
                key={`${pagination.totalData}-${pagination.page}`}
                columns={this.tableColumns}
                data={this.getDataDetail()}
                toCount={pagination.totalData}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
              />
              {this.props.displayActive && (
                <div style={{ textAlign: "right", marginTop: "10px" }}>
                  <SimpleButton
                    text="Upload"
                    type="button"
                    onClick={this.handleUploadFileModalVisibility}
                  />
                  <SimpleButton
                    text="Simpan"
                    type="button"
                    onClick={() =>
                      this.handleBeforeSubmit(
                        "Apakah anda yakin ingin menyimpan data ini?"
                      )
                    }
                  />
                </div>
              )}
              {this.state.simpleAlert && (
                <SimpleAlert
                  visible={this.state.simpleAlert}
                  onClickClose={() => this.checkIfDelete()}
                  content={
                    <div>
                      <p>Apakah anda yakin ingin menghapus dokumen ini?</p>
                    </div>
                  }
                  additionalButtons={
                    <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                      <SimpleButton
                        secondary
                        onClick={() => this.checkIfDelete()}
                      >
                        Batal
                      </SimpleButton>
                      <SimpleButton
                        onClick={this.handleDeleteConfirmation}
                        type="button"
                      >
                        Iya
                      </SimpleButton>
                    </FlexView>
                  }
                />
              )}
              {this.state.saveAlert && (
                <SimpleAlert
                  title={"Information"}
                  content={
                    <div>
                      <p>
                        {this.state.warningMessage}
                        <br />
                        Mohon periksa kembali.
                      </p>
                    </div>
                  }
                  visible={this.state.saveAlert}
                  onClickClose={this.handleSaveAlertModalVisibility}
                  additionalButtons={
                    <SimpleButton
                      type="button"
                      text="OK"
                      onClick={() => this.handleSaveAlertModalVisibility()}
                    />
                  }
                />
              )}
              {this.state.deleteAlert && (
                <SimpleAlert
                  title={"Information"}
                  content={
                    <div>
                      <p>{this.state.warningMessage}</p>
                    </div>
                  }
                  visible={this.state.deleteAlert}
                  onClickClose={this.handleDeleteAlertModalVisibility}
                  additionalButtons={
                    <FlexView
                      vAlignContent="center"
                      style={{ alignItems: "end" }}
                    >
                      <SimpleButton
                        type="button"
                        text="Batal"
                        onClick={() => this.handleDeleteAlertModalVisibility()}
                      />
                      <SimpleButton
                        type="button"
                        text="OK"
                        onClick={() =>
                          this.handleRemoveRow(this.state.selectedRowIndex)
                        }
                      />
                    </FlexView>
                  }
                />
              )}
              {this.state.saveSubmitAlert && (
                <SimpleAlert
                  title={"Information"}
                  content={
                    <div>
                      <p>{this.state.warningMessage}</p>
                    </div>
                  }
                  visible={this.state.saveSubmitAlert}
                  onClickClose={this.handleSaveSubmitAlertModalVisibility}
                  additionalButtons={
                    <FlexView
                      vAlignContent="center"
                      style={{ alignItems: "end" }}
                    >
                      <SimpleButton
                        type="button"
                        text="Batal"
                        onClick={() =>
                          this.handleSaveSubmitAlertModalVisibility()
                        }
                      />
                      <SimpleButton
                        type="button"
                        text="OK"
                        onClick={() => this.handleSubmit()}
                      />
                    </FlexView>
                  }
                />
              )}
              {this.state.duplicatePart && (
                <SimpleAlert
                  title={"Peringatan"}
                  content={
                    "Data Part sudah terdapat pada list. Mohon dicek kembali"
                  }
                  visible={this.state.duplicatePart}
                  onClickClose={this.handleDuplicatePartAlert}
                  additionalButtons={
                    <SimpleButton
                      type="button"
                      text="OK"
                      onClick={this.handleDuplicatePartAlert}
                    />
                  }
                />
              )}
            </form>

            {this.state.uploadFileModalVisible && (
              <SimpleUploadExcel
                downloadError={true}
                visible={this.state.uploadFileModalVisible}
                onChange={this.handleOnSubmitFile}
                onDownloadTemplate={this.handleDownloadTemplate}
                onDownloadLogError={this.handleDownloadLogError}
                onClickClose={() => this.handleUploadFileModalVisibility()}
              />
            )}

            <SimpleLoadingOverlay active={this.state.loading} />
            {this.state.printModalVisible && (
              <SimplePrintTable onClearPrint={this.handlePrint} />
            )}
          </ModalContainer>
        }
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(MasterPartPriceModifying);
